package com.eladfinish.bible.contest.features.installTime.domain.model

enum class BlockReason {
    FEATURE_DISABLED,
    NOT_ENOUGH_TIME_SINCE_INSTALL,
    NOT_ENOUGH_TIME_SINCE_UPDATE,
    MISSING_INSTALL_INFO,
}
